module.exports = __webpack_public_path__ + "img/gallery_inactive.9861acde.svg";